/**
 * US footer overrides (BC-4427). Mirrors the style of `hde-country-gating.ts`
 * — pure structural helpers + a US-specific replacement for the Memberships
 * group, consumed by `AppPage.tsx` when assembling the footer columns.
 */

export const isUS = (countryCode: string): boolean =>
    countryCode.toUpperCase() === 'US';

interface FooterGroupShape {
    links: Array<{ title: string }>;
}

/**
 * Returns a copy of the group with any link whose `title` appears in
 * `titlesToHide` removed. Structurally typed so it works against either the
 * Rocco footer or header link shapes.
 */
export const filterFooterGroupLinks = <T extends FooterGroupShape>(
    group: T,
    titlesToHide: ReadonlyArray<string>,
): T => {
    const hide = new Set(titlesToHide);
    return {
        ...group,
        links: group.links.filter((link) => !hide.has(link.title)),
    };
};

/**
 * US-only Memberships column. Points at the B2B marketing pages, which are
 * served at the root paths of the business subdomain
 * (`business.{AP_DOMAIN_PLACE}/professionals` and `/brands`). The
 * `{AP_DOMAIN_PLACE}` placeholder is resolved against the active country
 * domain by `placeCountryDomain` in `AppPage.tsx`.
 */
export const US_FOOTER_MEMBERSHIP_LINKS = {
    title: 'Memberships',
    links: [
        {
            title: 'For Professionals',
            to: 'https://business.{AP_DOMAIN_PLACE}/professionals',
            newTab: true,
        },
        {
            title: 'For Suppliers',
            to: 'https://business.{AP_DOMAIN_PLACE}/brands',
            newTab: true,
        },
    ],
};
